// portal-sesion-y-candados-optimizacion: los pendientes viven en `auth`
// (persistido con la sesión); este módulo solo hace la aceptación.
const state = {
    error: null
};

export default state;
